// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__XnjoT","modalBody":"Modal_modalBody__wwnsq"};